module.exports = __webpack_public_path__ + "media/images/illustration_2-3212d50b7f71a1f0072ec55fda399e03.png";